module.exports = __webpack_public_path__ + "img/table-solid.27a629d8.svg";